module.exports = __webpack_public_path__ + "img/ZOOKEEPER.d9bab28a.png";